import { render, staticRenderFns } from "./attachment-file-item.vue?vue&type=template&id=13cc205a"
import script from "./attachment-file-item.vue?vue&type=script&lang=js"
export * from "./attachment-file-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports